/** Ukrainian: the source dictionary. Every other language must provide the same keys. */
export const uk = {
  'app.skip': 'Перейти до вмісту',
  'app.loading': 'Завантаження…',
  'nav.cases': 'Мої справи',
  'nav.privacy': 'Мої дані',
  'nav.main': 'Основна навігація',
  'lang.label': 'Мова',
  'theme.label': 'Тема оформлення',
  'theme.system': 'Як у системі',
  'theme.light': 'Світла',
  'theme.dark': 'Темна',

  'common.retry': 'Спробувати ще раз',
  'common.back': 'Назад',
  'common.cabinet': 'Особистий кабінет',

  'login.title': 'Вхід до кабінету',
  'login.intro': 'Тут видно, як просувається ваша справа. Тут же можна передати нам документи і написати менеджеру. Пароль не потрібен — ми надішлемо одноразовий код.',
  'login.method': 'Як надіслати код',
  'login.byPhone': 'SMS на телефон',
  'login.byEmail': 'Лист на email',
  'login.phoneLabel': 'Номер телефону',
  'login.emailLabel': 'Електронна пошта',
  'login.destHint': 'Той, який ви повідомили нашому менеджеру.',
  'login.phonePlaceholder': '+380 67 123 45 67',
  'login.emailPlaceholder': 'name@example.com',
  'login.submit': 'Отримати код',
  'login.sending': 'Надсилаємо…',
  'login.codeTitle': 'Введіть код',
  'login.codeSentPhone': 'Ми надіслали SMS на {dest}.',
  'login.codeSentEmail': 'Ми надіслали лист на {dest}.',
  'login.codeNote': 'Якщо ці контакти є у нас, код прийде протягом хвилини. Він дійсний 10 хвилин.',
  'login.codeLabel': 'Код із 6 цифр',
  'login.verify': 'Увійти',
  'login.verifying': 'Перевіряємо…',
  'login.resend': 'Надіслати код ще раз',
  'login.resendIn': 'Надіслати ще раз можна через {time}',
  'login.resent': 'Новий код надіслано.',
  'login.change': 'Змінити номер або email',
  'login.help': 'Код не приходить? Зателефонуйте нам — допоможемо.',
  'login.empty': 'Введіть, будь ласка, номер телефону або email.',

  'err.invalid_destination': 'Схоже, у номері чи адресі помилка. Перевірте, будь ласка.',
  'err.invalid_code': 'Код не підійшов або вже недійсний. Перевірте цифри або попросіть новий код.',
  'err.rate_limited': 'Забагато спроб. Зачекайте, будь ласка, кілька хвилин і спробуйте знову.',
  'err.rate_limited_wait': 'Забагато спроб. Спробувати знову можна через {time}.',
  'err.network': "Немає з'єднання. Перевірте інтернет і спробуйте ще раз.",
  'err.unauthorized': 'Сеанс завершився. Увійдіть, будь ласка, знову.',
  'err.forbidden': 'Немає доступу до цієї сторінки.',
  'err.not_found': 'Не вдалося знайти цю сторінку або документ.',
  'err.validation': 'Перевірте, будь ласка, введені дані.',
  'err.generic': 'Щось пішло не так. Спробуйте ще раз або напишіть нам у чат.',
  'err.code_incomplete': 'Введіть усі 6 цифр коду.',

  'cases.title': 'Мої справи',
  'cases.empty': "Поки що тут немає справ. Якщо ви щойно звернулися до нас, справа з'явиться після розмови з менеджером.",
  'cases.number': 'Справа № {n}',
  'cases.updated': 'Оновлено {date}',
  'cases.now': 'Зараз',
  'cases.open': 'Відкрити справу',

  'case.sections': 'Розділи сторінки',
  'case.stages': 'Етапи',
  'case.stage.done': 'Виконано',
  'case.stage.current': 'Зараз',
  'case.stage.next': 'Далі',
  'case.needs': 'Що потрібно від вас',
  'case.needsIntro': 'Сфотографуйте документ телефоном або виберіть файл. Головне, щоб текст було добре видно.',
  'case.needsDone': 'Дякуємо. Зараз від вас нічого не потрібно.',
  'case.needsCount': 'Залишилось: {n}',
  'case.rejectedReason': 'Що не так: {reason}',
  'case.rejectedNoReason': 'Менеджер пояснить у чаті, що потрібно виправити.',
  'case.replaceHint': 'Помилилися з файлом? Можна надіслати інший, поки ми його не перевірили.',

  'status.missing': 'Потрібно',
  'status.optional': 'За бажанням',
  'status.uploaded': 'На перевірці',
  'status.accepted': 'Прийнято',
  'status.rejected': 'Потрібно переробити',

  'upload.takePhoto': 'Сфотографувати',
  'upload.chooseFile': 'Вибрати файл',
  'upload.replace': 'Надіслати інший файл',
  'upload.limits': 'Фото або PDF, до {mb} МБ.',
  'upload.preparing': 'Готуємо…',
  'upload.uploading': 'Завантаження: {pct}%',
  'upload.finishing': 'Зберігаємо…',
  'upload.done': 'Файл отримано. Ми перевіримо його найближчим часом.',
  'upload.tooLarge': 'Файл завеликий ({size}). Максимум — {mb} МБ. Спробуйте сфотографувати ще раз або зменшити PDF.',
  'upload.badType': 'Цей тип файлу не підходить. Підійдуть фото (JPG, PNG, HEIC) або PDF.',
  'upload.empty': 'Файл порожній. Спробуйте вибрати його ще раз.',
  'upload.failed': 'Не вдалося завантажити файл.',
  'upload.retry': 'Спробувати ще раз',
  'upload.cancel': 'Скасувати',
  'upload.progress': 'Хід завантаження',

  'docs.fromUs': 'Документи від нас',
  'docs.empty': "Коли ми підготуємо документи, вони з'являться тут.",
  'docs.download': 'Завантажити',
  'docs.opening': 'Відкриваємо…',
  'docs.yours': 'Надіслані вами',

  'chat.title': 'Чат з менеджером',
  'chat.intro': 'Пишіть, коли вам зручно. Менеджер відповість якнайшвидше.',
  'chat.urgentCall': 'У термінових питаннях краще зателефонувати:',
  'chat.empty': 'Повідомлень поки немає. Можете поставити будь-яке питання.',
  'chat.label': 'Ваше повідомлення',
  'chat.placeholder': 'Напишіть повідомлення…',
  'chat.send': 'Надіслати',
  'chat.sending': 'Надсилається…',
  'chat.failed': 'Не надіслано.',
  'chat.retry': 'Надіслати ще раз',
  'chat.you': 'Ви',
  'chat.manager': 'Менеджер',
  'chat.offline': "Немає з'єднання. Нові повідомлення з'являться, щойно зв'язок відновиться.",

  'timeline.title': 'Історія',
  'timeline.empty': 'Поки що подій немає.',
  'event.case_created': 'Справу відкрито',
  'event.state_changed': 'Новий етап: {state}',
  'event.state_changed_plain': 'Справа перейшла на новий етап',
  'event.document_uploaded': 'Документ отримано: {doc}',
  'event.document_accepted': 'Документ прийнято: {doc}',
  'event.documents_accepted': 'Документи прийнято: {docs}',
  'event.documents_uploaded': 'Документи отримано: {docs}',
  'event.document_rejected': 'Документ потрібно переробити: {doc}',
  'event.document_ready': 'Документ підготовлено: {doc}',
  'event.document_plain': 'Оновлення щодо документів',
  'event.message': 'Нове повідомлення від менеджера',
  'event.generic': 'Оновлення у справі',
  'event.order_shipped': 'Замовлення відправлено',
  'event.order_completed': 'Замовлення виконано',

  'privacy.title': 'Мої дані',
  'privacy.intro': 'Ми зберігаємо лише те, що потрібно для вашої справи, і нікому не передаємо без потреби.',
  'privacy.exportTitle': 'Копія ваших даних',
  'privacy.exportHint': 'Файл з усім, що ми про вас зберігаємо (за правилами GDPR).',
  'privacy.export': 'Завантажити мої дані',
  'privacy.exporting': 'Готуємо файл…',
  'privacy.exported': 'Файл збережено на ваш пристрій.',
  'privacy.erase': 'Якщо хочете, щоб ми видалили ваші дані, напишіть нам. Ми відповімо протягом 30 днів.',
  'privacy.contacts': 'Контакти',
  'privacy.phone': 'Телефон',
  'privacy.duty': 'Цілодобово',
  'privacy.email': 'Email',
  'privacy.dpo': 'Питання щодо даних',
  'privacy.company': 'Компанія',
  'privacy.address': 'Адреса',
  'privacy.session': 'Вихід',
  'privacy.logoutHint': 'Якщо ви користуєтеся чужим телефоном чи комп’ютером, вийдіть після роботи.',
  'privacy.logout': 'Вийти з кабінету',
  'privacy.loggingOut': 'Виходимо…',

  // --- phase 5: steps, notifications, feedback, case site
  'nav.notifications': 'Повідомлення',
  'notif.title': 'Повідомлення',
  'notif.intro': 'Тут зберігаються всі повідомлення щодо ваших справ, навіть якщо лист чи SMS не дійшли.',
  'notif.empty': 'Поки що повідомлень немає.',
  'notif.via.email': 'Надіслано на e-mail',
  'notif.via.sms': 'Надіслано в SMS',
  'notif.via.telegram': 'Надіслано в Telegram',
  'notif.via.viber': 'Надіслано у Viber',
  'notif.via.whatsapp': 'Надіслано у WhatsApp',
  'notif.logged': 'Записано в кабінеті',
  'notif.queued': 'Надішлемо вранці',
  'notif.new': 'Нове',
  'notif.unread': 'Нових повідомлень: {n}',
  'notif.more': 'Показати попередні',
  'notif.today': 'Сьогодні',
  'notif.yesterday': 'Учора',
  'step.accepted': 'Прийняли справу',
  'step.docs_collecting': 'Збираємо документи',
  'step.docs_ready': 'Документи готові',
  'step.picked_up': 'Тіло забрали',
  'step.in_transit': 'У дорозі',
  'step.border_crossed': 'Перетнули кордон',
  'step.delivered': 'Доставили',
  'step.burial': 'Поховання',
  'step.hint.accepted': 'Ми прийняли справу і вже працюємо над нею.',
  'step.hint.docs_collecting': 'Збираємо потрібні документи. Якщо щось знадобиться від вас, ми напишемо.',
  'step.hint.docs_ready': 'Документи готові. Готуємо наступний крок.',
  'step.hint.picked_up': 'Ми подбаємо про все необхідне.',
  'step.hint.in_transit': 'Ми повідомимо, коли буде перетнуто кордон і коли прибудемо.',
  'step.hint.in_transit_local': 'Ми повідомимо, коли прибудемо.',
  'step.hint.border_crossed': 'Кордон позаду. Ми повідомимо, коли прибудемо.',
  'step.hint.delivered': 'Ми на місці. Менеджер зв’яжеться з вами щодо наступних кроків.',
  'step.hint.burial': 'Ми поруч, якщо вам знадобиться допомога. Напишіть менеджеру в чаті.',
  'event.step': 'Новий крок: {step}',
  'feedback.title': 'Як ми впоралися?',
  'feedback.intro': 'Кілька слів від вас допоможуть нам бути уважнішими до інших родин.',
  'feedback.rating': 'Оцінка від 1 до 5',
  'feedback.rate': '{n} з 5',
  'feedback.scale': '1 — погано, 5 — дуже добре',
  'feedback.text': 'Що ми могли б зробити краще? (необовʼязково)',
  'feedback.optOut': 'Більше не надсилати мені таких запитів',
  'feedback.submit': 'Надіслати відповідь',
  'feedback.sending': 'Надсилаємо…',
  'feedback.pickRating': 'Виберіть, будь ласка, оцінку.',
  'feedback.thanks': 'Дякуємо. Ваша відповідь важлива для нас.',
  'feedback.expired': 'Термін для відповіді минув. Ви завжди можете написати менеджеру в кабінеті.',
  'feedback.optedOut': 'Ви відмовилися від таких запитів, тож ми їх більше не надсилатимемо.',
  'feedback.optedOutDone': 'Більше не надсилатимемо вам таких запитів.',
  'feedback.notFound': 'Посилання недійсне. Якщо хочете поділитися враженнями, напишіть менеджеру в кабінеті.',
  'feedback.card': 'Відгук',
  'feedback.cardIntro': 'Якщо маєте хвилину, розкажіть, як ми впоралися.',
  'feedback.toCabinet': 'Перейти до кабінету',
  'privacy.feedbackTitle': 'Запити на відгук',
  'privacy.feedbackHint': 'Після завершення справи ми можемо один раз запитати, як ми впоралися.',
  'privacy.feedbackOptOut': 'Не надсилати мені запити на відгук',
  'privacy.saved': 'Збережено.',
  'site.contacts': 'Звʼязатися з нами',
} as const;

export type DictKey = keyof typeof uk;
export type Dict = Record<DictKey, string>;
